import React from 'react';
import NewsCard from '../components/NewsCard'; // Adjust path as necessary
import dummyWideImg from '../images/dummy-image.jpg'; // Adjust path as necessary

const NewsDetailPage = ({news}) => {
  // Placeholder data - fetch dynamically
  const article = {
    title: news.title,
    author: "Dr. Expert",
    date: news.date,
    category:  news.category,
    content: [
      "Explore the world of medical specialties through our blog's spotlight feature. From cardiology to pediatrics, we share in-depth articles written by our expert physicians. Discover the latest advancements, best practices, and insightful perspectives designed to inform and inspire healthcare professionals and enthusiasts alike.",
      "Whether you're looking to deepen your understanding of medical fields or stay updated on innovative techniques, our blog is your gateway to expert knowledge and thought leadership.",
      "This week, we focus on the advancements in non-invasive diagnostic tools within cardiology. Techniques like advanced cardiac MRI and CT angiography are providing unprecedented views of the heart and vasculature, allowing for earlier and more accurate diagnoses of conditions such as coronary artery disease and cardiomyopathies.",
      "Furthermore, in pediatrics, the integration of telehealth has significantly improved access to specialist care for children in remote areas. We discuss the challenges and successes of implementing virtual care models and their impact on patient outcomes.",
      "Stay tuned for next week's feature where we will explore breakthroughs in respiratory medicine, including new biologic therapies for severe asthma and COPD.",
      "Our commitment is to keep you informed and engaged with the evolving landscape of healthcare. We believe that knowledge sharing is crucial for advancing medical excellence and improving patient well-being across all specialties."
    ],
    imageUrl: dummyWideImg // Optional image for the article
  };

 const handleBack = () => {
     window.history.back();
 }

 return (
   <>


     <article className="col-lg-9 mx-auto my-2"> {/* Constrain width */}

     {/* Back Button */}
     <button type="button"  className="btn btn-link text-decoration-none text-black mb-4" onClick={handleBack}>
        &larr; Back to News
     </button>

       {/* Article Header */}
       <header className="mb-4 border-bottom pb-3">
         <h1 className="fw-bold mb-2 display-6">{article.title}</h1>
         <div className="small text-muted">
           <span>By {article.author}</span> | <span>{article.date}</span> | <span className="badge bg-primary-subtle border border-primary-subtle text-primary-emphasis rounded-pill">{article.category}</span>
         </div>
       </header>

       {/* Optional Article Image */}
       {article.imageUrl && (
         <div className="mb-4 rounded overflow-hidden shadow-sm">
           <img
             src={article.imageUrl}
             alt={article.title}
             className="img-fluid w-100" // Responsive image
             onError={(e) => e.target.style.display='none'}
            />
         </div>
       )}

       {/* Article Content */}
       <div className="fs-5 text-secondary"> {/* Slightly larger text for readability */}
         {article.content.map((paragraph, index) => (
           <p key={index} className="mb-3">{paragraph}</p>
         ))}
       </div>

     </article>
   </>
 )
}
export default NewsDetailPage;